import { render } from "./EmbeddingModelSummaryCard.vue?vue&type=template&id=5a96957e&scoped=true&ts=true"
import script from "./EmbeddingModelSummaryCard.vue?vue&type=script&lang=ts"
export * from "./EmbeddingModelSummaryCard.vue?vue&type=script&lang=ts"

import "./EmbeddingModelSummaryCard.vue?vue&type=style&index=0&id=5a96957e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a96957e"]])

export default __exports__